import { mapDataSearchToProperty } from 'client/contexts/Property/mappers'
import {
  mapAffiliateParams,
  mapDatesParams,
  mapFilterParams,
  mapMarketParams,
  mapPaginationParams,
  mapPaxesParams,
} from 'src/effects/Search/mappers'
import type { FetchMapPropertiesParams, FetchMapPropertiesResponse } from './requests'

export function buildSearchMapPropertiesPayload(params: FetchMapPropertiesParams) {
  const { latitude, longitude, filters, highlightedProperty, currency, minSellingRate, priceType } =
    params

  return {
    ...(latitude && { latitude: Number(latitude) }),
    ...(longitude && { longitude: Number(longitude) }),
    highlighted: highlightedProperty,
    sortBy: 'price',
    currency,
    minSellingRate,
    price_type: priceType,
    ...(params.excludedIDs && { excludedIDs: params.excludedIDs }),
    ...(params.device && { device: params.device }),
    ...mapDatesParams(params),
    ...mapMarketParams(params),
    ...mapPaxesParams(params),
    ...mapFilterParams(filters),
    ...mapPaginationParams({ page: 0, offset: params.offset }),
    ...mapAffiliateParams(params),
    ...(params.boxShape && {
      box_shape: {
        top_left: {
          lon: params.boxShape.topLeft.longitude,
          lat: params.boxShape.topLeft.latitude,
        },
        bottom_right: {
          lon: params.boxShape.bottomRight.longitude,
          lat: params.boxShape.bottomRight.latitude,
        },
      },
    }),
  }
}

export function mapDataSearchMapToPropertiesCollection(
  data: FetchMapPropertiesResponse['data']['properties'] = []
) {
  return data.map(p => mapDataSearchToProperty(p))
}
